import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TelegramAuthGuard } from './components/Auth/TelegramAuthGuard';
import { DebugOverlay } from './components/Debug/DebugOverlay';
import { Home } from './pages/Home/Home';
import { Sessions } from './pages/Sessions/Sessions';
import { SessionCalls } from './pages/SessionCalls/SessionCalls';

function App() {
  return (
    <AuthProvider>
      <TelegramAuthGuard>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/session-calls/:sessionId" element={<SessionCalls />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </TelegramAuthGuard>
      <DebugOverlay />
    </AuthProvider>
  );
}

export default App;